import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { Component, OnInit, Input, HostListener } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { URLSearchParams } from '@angular/http';

import { Service } from 'app/admin/services/service.model';
import { ServiceService } from 'app/admin/services/service.service';
import { compareElements } from 'app/shared/validators/generic-validators';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { unsavedFormCheck } from 'app/shared/validators/generic-validators';

@Component({
  templateUrl: './add-service.component.html',
  styleUrls: ['./add-service.component.css']
})

/**
 * Dialog component for Admin Service deletion.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
 */
export class AddServiceComponent implements OnInit {
  @Input() addService: ServiceService;
  serviceCategotyType: string;
  addServiceForm: FormGroup;
  flagAddService = false;
  argEntityId: number;
  argEntityValues: any[] = [];
  savingService = false;
  
  formErrors = {
    'serviceName': '',
  };

  validationMessages = {
    'serviceName': {
      'required': 'Required field value.',
    }
  };

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private addServiceService: ServiceService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService) {
  }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.addServiceForm = this.formBuilder.group({
      serviceName: ['', Validators.required],
    });

    this.addServiceForm.valueChanges.subscribe(data => this.onValueChanged(data));
    this.onValueChanged(); // (re)set validation messages now
  }

  onValueChanged(data?: any) {
    if (!this.addServiceForm) {
      return;
    }
    const form = this.addServiceForm;

    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && control.touched && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + ' ';
        }
      }
    }
  }

  getSelectedCategoryTypeKey() {
    // $todo: Check whether there is a better way to traverse.
    switch (this.serviceCategotyType) {
        case 'Act as trustee': return 'TRUSTEE';
        case 'Domicile sec': return 'DOMICILE_SEC';
        case 'Domicile plus': return 'DOMICILE_PLUS';
        case 'Management Services': return 'MGT_SVC';
        case 'Mediate in selling the company': return 'MEDIATE_SELLING';
        case 'Partner': return 'PARTNER';
        case 'Supplying a coduit company': return 'SUPPLY_CONDUIT_COMPANY';
        case 'Other': return 'OTHER';
    }
  }

  // @todo To be updated once REST is available.
  onSubmit({ value, valid }) {
    this.flagAddService = true;
    this.addServiceForm.disable();
    const serviceSaveData = new Service();
    serviceSaveData.serviceType = this.getSelectedCategoryTypeKey();
    serviceSaveData.serviceName = value.serviceName.trim();
    this.savingService = true;
    this.addServiceService.addNewAdminService(serviceSaveData)
    .subscribe(
      success => {
          this.savingService = false;
          if (success.flagResult) {
              this.dialogRef.close(success.arrResult);
          }
          this.trackingService
              .emitEvent(
              TrackingConstants.ADMIN_SERVICE_MANAGEMENT,
              TrackingConstants.SAVE_ADMIN_SERVICE,
              TrackingConstants.SUCCESS, 1);
          this.callSnackBarService(success);
      },
      err => {
          this.savingService = false;
          this.trackingService
              .emitEvent(
              TrackingConstants.ADMIN_SERVICE_MANAGEMENT,
              TrackingConstants.SAVE_ADMIN_SERVICE,
              TrackingConstants.FAILURE, 0);
          this.callSnackBarService(err);
      }
      );
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
      MessageService.ADD_ADMIN_SERVICE_SUCCESS,
      MessageService.ACTION_FAILURE);
  }

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    unsavedFormCheck(event, this.dialogRef, this.addServiceForm);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/services/addservice/add-service.component.ts